import { ProjConstants } from 'src/app/utils/proj.constant';

export const HeatWaveMapConstants = {
    CommonLayers : [
      {
        layerNameType : 'STATE',
        serviceType : 'WmsLayer',
        view : 'Both',
        type : 'Base',
        env : 'bg_color:#cccccc;bg_opacity:0.7;bg_width:0.5;i_stroke_color:#000000;i_stroke_width:1;i_shadow_color:#000000;i_shadow_opacity=0.1;i_shadow_width:7;o_s_boundary_color:#aaaaaa;o_s_boundary_width:0.5;s_boundary_color:#000000;s_boundary_width:0.1;m_boundary_color:#000000;m_boundary_width:0.5;text_color:#000000;b_s_color:#000000',
        pane : 'popup',
        styles:'INDIA_STATE_NAMES',
        maxZoom:7
      },
      // {
      //   layerNameType : 'MASK_LAYER',
      //   serviceType : 'WmsLayer',
      //   view : 'Both',
      //   type : 'Base',
      //   env : 'bg_color:#cccccc;bg_opacity:0.7;bg_width:0.5;i_stroke_color:#000000;i_stroke_width:1;i_shadow_color:#000000;i_shadow_opacity=0.1;i_shadow_width:7;o_s_boundary_color:#aaaaaa;o_s_boundary_width:0.5;s_boundary_color:#000000;s_boundary_width:0.1;m_boundary_color:#000000;m_boundary_width:0.5;text_color:#000000;b_s_color:#000000',
      //   pane : 'heatMap',
      //   styles:'HEATWAVE:world_view_white,HEATWAVE:inverse_mask',
      //   minZoom:8,
      //   maxZoom:9
      // },
      {
        layerNameType : 'MASK_LAYER',
        serviceType : 'WmsLayer',
        name : 'stateMask',
        view : 'Both',
        type : 'Inverse',
        env : 'bg_color:#cccccc;bg_opacity:0.7;bg_width:0.5;i_stroke_color:#000000;i_stroke_width:1;i_shadow_color:#000000;i_shadow_opacity=0.1;i_shadow_width:7;o_s_boundary_color:#aaaaaa;o_s_boundary_width:0.5;s_boundary_color:#000000;s_boundary_width:0.1;m_boundary_color:#000000;m_boundary_width:0.5;text_color:#000000;b_s_color:#000000',
        pane : 'mask',
        styles:'HEATWAVE:world_view_white,HEATWAVE:inverse_mask',
      },
      // {
      //   layerNameType : 'STATE',
      //   serviceType : 'VectorLayer',
      //   view : 'Both',
      //   type : 'Time',
      //   env : 'bg_color:#cccccc;bg_opacity:0.7;bg_width:0.5;i_stroke_color:#000000;i_stroke_width:1;i_shadow_color:#000000;i_shadow_opacity=0.1;i_shadow_width:7;o_s_boundary_color:#aaaaaa;o_s_boundary_width:0.5;s_boundary_color:#000000;s_boundary_width:0.1;m_boundary_color:#000000;m_boundary_width:0.5;text_color:#000000;b_s_color:#000000',
      //   pane : 'popup'
      // },
      {
        layerNameType : 'DISTRICT',
        serviceType : 'WmsLayer',
        view : 'Both',
        type : 'Base',
        env : 'bg_color:#cccccc;bg_opacity:0.7;bg_width:0.5;i_stroke_color:#000000;i_stroke_width:1;i_shadow_color:#000000;i_shadow_opacity=0.1;i_shadow_width:7;o_s_boundary_color:#aaaaaa;o_s_boundary_width:0.5;s_boundary_color:#000000;s_boundary_width:0.1;m_boundary_color:#000000;m_boundary_width:0.5;text_color:#000000;b_s_color:#000000',
        pane : 'village',
        styles:'INDIA_DISTRICT_NAMES',
        minZoom:8,
        maxZoom:9
      },
      {
        layerNameType : 'DISTRICT',
        serviceType : 'VectorLayer',
        view : 'Both',
        type : 'Time',
        env : 'bg_color:#cccccc;bg_opacity:0.7;bg_width:0.5;i_stroke_color:#000000;i_stroke_width:1;i_shadow_color:#000000;i_shadow_opacity=0.1;i_shadow_width:7;o_s_boundary_color:#aaaaaa;o_s_boundary_width:0.5;s_boundary_color:#000000;s_boundary_width:0.1;m_boundary_color:#000000;m_boundary_width:0.5;text_color:#000000;b_s_color:#000000',
        dataurl : 'heatWatches/getHeatWatchesData' ,
        hval :"hwv",
        hcat : "hwc",
        pane : 'district'
      },
      {
        layerNameType : 'BLOCKS',
        serviceType : 'WmsLayer',
        view : 'Both',
        type : 'Base',
        env : 'bg_color:#cccccc;bg_opacity:0.7;bg_width:0.5;i_stroke_color:#000000;i_stroke_width:1;i_shadow_color:#000000;i_shadow_opacity=0.1;i_shadow_width:7;o_s_boundary_color:#aaaaaa;o_s_boundary_width:0.5;s_boundary_color:#000000;s_boundary_width:0.1;m_boundary_color:#000000;m_boundary_width:0.5;text_color:#000000;b_s_color:#000000',
        pane : 'village',
        styles:'ALL_INDIA_BLOCK_NAMES',
        minZoom:9
      },
      {
        layerNameType : 'SCHOOLS',
        serviceType : 'WmsLayer',
        view : 'Both',
        type : 'Base',
        env : 'bg_color:#cccccc;bg_opacity:0.7;bg_width:0.5;i_stroke_color:#000000;i_stroke_width:1;i_shadow_color:#000000;i_shadow_opacity=0.1;i_shadow_width:7;o_s_boundary_color:#aaaaaa;o_s_boundary_width:0.5;s_boundary_color:#000000;s_boundary_width:0.1;m_boundary_color:#000000;m_boundary_width:0.5;text_color:#000000;b_s_color:#000000',
        pane : 'popUp',
        // styles:'ALL_INDIA_STATE_NAMES',
        minZoom:9,
        maxZoom:13
      },
      {
        layerNameType : 'anganwadi_points_telangana',
        serviceType : 'WmsLayer',
        view : 'Both',
        type : 'Base',
        env : 'bg_color:#cccccc;bg_opacity:0.7;bg_width:0.5;i_stroke_color:#000000;i_stroke_width:1;i_shadow_color:#000000;i_shadow_opacity=0.1;i_shadow_width:7;o_s_boundary_color:#aaaaaa;o_s_boundary_width:0.5;s_boundary_color:#000000;s_boundary_width:0.1;m_boundary_color:#000000;m_boundary_width:0.5;text_color:#000000;b_s_color:#000000',
        pane : 'popUp',
        // styles:'ALL_INDIA_STATE_NAMES',
        minZoom:9,
        maxZoom:13
      },
      {
        layerNameType : 'healthcare_facility_points',
        serviceType : 'WmsLayer',
        view : 'Both',
        type : 'Base',
        env : 'bg_color:#cccccc;bg_opacity:0.7;bg_width:0.5;i_stroke_color:#000000;i_stroke_width:1;i_shadow_color:#000000;i_shadow_opacity=0.1;i_shadow_width:7;o_s_boundary_color:#aaaaaa;o_s_boundary_width:0.5;s_boundary_color:#000000;s_boundary_width:0.1;m_boundary_color:#000000;m_boundary_width:0.5;text_color:#000000;b_s_color:#000000',
        pane : 'popUp',
        // styles:'ALL_INDIA_STATE_NAMES',
        minZoom:9,
        maxZoom:13
      },
      {
        layerNameType : 'BLOCKS',
        serviceType : 'VectorLayer',
        view : 'Both',
        type : 'Time',
        env : 'bg_color:#cccccc;bg_opacity:0.7;bg_width:0.5;i_stroke_color:#000000;i_stroke_width:1;i_shadow_color:#000000;i_shadow_opacity=0.1;i_shadow_width:7;o_s_boundary_color:#aaaaaa;o_s_boundary_width:0.5;s_boundary_color:#000000;s_boundary_width:0.1;m_boundary_color:#000000;m_boundary_width:0.5;text_color:#000000;b_s_color:#000000',
        dataurl : 'heatWatches/getHeatWatchesData' ,
        hval :"hwv",
        hcat : "hwc",
        pane : 'block',
        minZoom : 9,
      },
      ],
      // schoolAlerts:[
      //   {
      //     layerNameType : 'SCHOOLS',
      //     serviceType : 'WmsLayer',
      //     view : 'Both',
      //     type : 'Base',
      //     env : 'bg_color:#cccccc;bg_opacity:0.7;bg_width:0.5;i_stroke_color:#000000;i_stroke_width:1;i_shadow_color:#000000;i_shadow_opacity=0.1;i_shadow_width:7;o_s_boundary_color:#aaaaaa;o_s_boundary_width:0.5;s_boundary_color:#000000;s_boundary_width:0.1;m_boundary_color:#000000;m_boundary_width:0.5;text_color:#000000;b_s_color:#000000',
      //     pane : 'popUp',
      //     // styles:'ALL_INDIA_STATE_NAMES',
      //     // minZoom:9,
      //     maxZoom:13
      //   },
      // ],

      Legend:{
        colorValues: [
        {
            backgroundColor : ProjConstants.HEAT_WATCHES_LEGEND.normal,
            color : '#000000',
            text : 'Normal'
        },
        {
            backgroundColor : ProjConstants.HEAT_WATCHES_LEGEND.heat_waves,
            color : '#000000',
            text : 'Heatwave'
        },
        {
            backgroundColor : ProjConstants.HEAT_WATCHES_LEGEND.severe_heat_waves,
            color : '#FFFFFF',
            text : 'Severe Heatwave'
        }
    ],
    },

    schoolLegend: {
    colorValues: [
    //   {
    //     backgroundColor : ProjConstants.HEAT_WATCHES_LEGEND.normal,
    //     color : '#000000',
    //     text : 'Normal'
    // },
    // {
    //     backgroundColor : ProjConstants.HEAT_WATCHES_LEGEND.heat_waves,
    //     color : '#000000',
    //     text : 'Heatwave'
    // },
    // {
    //     backgroundColor : ProjConstants.HEAT_WATCHES_LEGEND.severe_heat_waves,
    //     color : '#FFFFFF',
    //     text : 'Severe Heatwave'
    // },
    {
        backgroundColor: '#800080',
        color: '#ffffff',
        text: 'School Alert'
      }
    ],
  }

}

export const HEATWAVE_SOURCE = {
  'IMD' : 'IMD_LONG_RANGE',
  'ECMWF' : 'ECMWF'
}

export const LOCTYPE_LAYER_MAPPING = {
  'State' : 'HEATWAVE:ALL_INDIA_STATE',
  'District' : 'HEATWAVE:ALL_INDIA_DISTRICT'
}

// export const CQLFILTER_MAPPING = {
//   STATE : 'UUID',
//   DISTRICT : 'State_UUID',
//   BLOCKS : 'Dist_UUID'
// }

export const CQLFILTER_MAPPING = {
  'State' : {
    DISTRICT : 'State_UUID',
    BLOCKS : 'State_UUID'
  },
  'District' : {
    DISTRICT : 'Dist_UUID',
    BLOCKS : 'Dist_UUID'
  }
}
